// hooks/useSubscriptionStatus.jsx

import { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { useAuth } from "./useAuth";

const useSubscriptionStatus = () => {
  const { currentUser, loading: authLoading } = useAuth();
  const [isSubscribed, setIsSubscribed] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) {
      console.log("[DEBUG] Waiting for Firebase Auth to load...");
      return;
    }

    if (!currentUser?.uid) {
      console.log("[DEBUG] No authenticated user found. Skipping Firestore check.");
      setIsSubscribed(false);
      setLoading(false);
      return;
    }

    console.log(`[DEBUG] Checking Firestore subscription for UID: ${currentUser.uid}`);

    const userDocRef = doc(db, "users", currentUser.uid);

    const unsubscribe = onSnapshot(
      userDocRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const userData = docSnap.data();
          console.log("[DEBUG] Full Firestore Document Data:", userData);

          const subscriptionData = userData?.subscription;
          console.log("[DEBUG] Extracted Subscription Data:", subscriptionData);

          const status = subscriptionData?.status?.toLowerCase();
          setSubscriptionStatus(status ?? null); 
          const VALID_STATUSES = ["active", "trialing", "pending"];
          if (VALID_STATUSES.includes(status)) {
            console.log(`[SUCCESS] Subscription is valid. Status: ${status}`);
            setIsSubscribed(true);
          } else {
            console.log("[DEBUG] Subscription status is not valid. Current status:", status);
            setIsSubscribed(false);
          }
        } else {
          console.log("[DEBUG] No subscription document found for UID:", currentUser.uid);
          setIsSubscribed(false);
          setSubscriptionStatus(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error("[FIRESTORE ERROR] Error fetching subscription status:", error);
        setIsSubscribed(false);
        setSubscriptionStatus(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [currentUser?.uid, authLoading]);

  return { isSubscribed, subscriptionStatus, loading }; // ✅ expose subscriptionStatus
};

export default useSubscriptionStatus;